import React, { createContext, useContext } from 'react'
import type MessagingService from './messagingService'

const MessagingServiceCtx = createContext<MessagingService | null>(null)

type Props = {
  service: MessagingService
  children: React.ReactNode
}

export const MessagingServiceProvider = ({ service, children }: Props) => {
  return (
    <MessagingServiceCtx.Provider value={service}>
      {children}
    </MessagingServiceCtx.Provider>
  )
}

export const useMessagingService = (): MessagingService => {
  const service = useContext(MessagingServiceCtx)
  if (!service) throw new Error('MessagingServiceProvider is missing')
  return service
}
